import React from 'react'
import { AppModal } from '@components'
import { isOpenGroupingExportsModal } from 'Pages/ReportsAlerts/ExportsGrouping/@signals'
import GroupingExportsModalContent from 'Pages/ReportsAlerts/ExportsGrouping/Modal/Content'


export default function GroupingExportsModal() {


	return <AppModal
		isOpen={!!isOpenGroupingExportsModal.value}
		controller={() => isOpenGroupingExportsModal.value = null}
		icon="file-export"
		title="Exported report data"
		hideActions
	>
		<GroupingExportsModalContent/>
	</AppModal>
}